export default __webpack_public_path__ + "static/media/ChangeDown.f8e0f71e.svg";